// extracted by mini-css-extract-plugin
export var boldText = "_8b-4";
export var checkboxContainer = "_8b-6";
export var closeIcon = "_8b-i";
export var container = "_8b-0";
export var drawer = "_8b-8";
export var drawerContent = "_8b-9";
export var extraSmallText = "_8b-5";
export var fulfillmentGroupTable = "_8b-e";
export var largeText = "_8b-3";
export var loadingSpinnerContainer = "_8b-j";
export var mediumText = "_8b-2";
export var narrow = "_8b-f";
export var notificationLink = "_8b-l";
export var packageCheckIconContainer = "_8b-7";
export var slideoutHeaderActions = "_8b-g";
export var slideoutHeaderActionsShifted = "_8b-h";
export var slideoutHeaderContainer = "_8b-a";
export var slideoutModal = "_8b-c";
export var stickyHeaderWrapper = "_8b-b";
export var table = "_8b-k";
export var tableContainer = "_8b-d";
export var tertiaryText = "_8b-1";